/**
 *
 * Asynchronously loads the component for AdminUpdateValidator
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/graphql/AdminUpdateValidator/loadable.js